module.exports = __webpack_public_path__ + "static/media/cowbell-808.470b5edb.wav";